export enum FiTasksViewMode {
    notCompleted = 0,
    completed = 1,
    cancelled = 2,
    archived = 3,
}
